import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Button } from '@mui/material';
import { useState, useCallback } from 'react';

interface CloseTicketDialogProps {
  open: boolean;
  onClose: () => void;
  onCloseTicket: (comments: string) => Promise<void>;
  isClosing: boolean;
}

export function CloseTicketDialog({ open, onClose, onCloseTicket, isClosing }: CloseTicketDialogProps) {
  const [comments, setComments] = useState('');
  
  const handleSubmit = useCallback(async () => {
    await onCloseTicket(comments);
    setComments('');
  }, [comments, onCloseTicket]);
  
  const handleClose = useCallback(() => {
    setComments('');
    onClose();
  }, [onClose]);
  
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Close Ticket</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please provide a comment for closing this ticket.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="comments"
          label="Closing Comments"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          color="primary" 
          disabled={isClosing}
        >
          {isClosing ? 'Closing...' : 'Close Ticket'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
